import React from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
});


const ToolbarButton = ({ icon, label, onClick = null, colorScheme, disabled }) => {
  return (
    <div
      style={{
        ...styles.buttonContainer,
        cursor: !disabled ? 'pointer' : 'not-allowed',
        color: !disabled ? GLOBAL_STYLES[colorScheme].fgColor : GLOBAL_STYLES.CONSTANTS.lightGray,
      }}
      className={!disabled ? 'toolbar-button' : null}
      onClick={!disabled ? onClick : null}
    >
      <i className={`fa ${icon} fa-3x`}/>
      <p style={styles.label}>{label}</p>
    </div>
  );
};

const styles = {
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 20,
  },
  label: {
    padding: 0,
    margin: 0,
    fontWeight: 'bold',
    fontSize: '0.8em',
    textAlign: 'center',
  },
};

export default connect(mapStateToProps)(ToolbarButton);